export default __webpack_public_path__ + "static/media/role-permission-icon.b07c1cfb.svg";